/*
 * DEMONTHA — dmt-video-lazy.js
 * ---------------------------------------------------------------------------
 * Amaç: Ürün sayfasındaki videolar görünür alana GİRMEDEN tek bayt inmesin,
 * girdiğinde kullanıcı hiçbir şeye tıklamadan kendiliğinden oynasın.
 *
 * Nasıl:
 *  - Liquid tarafı (snippets/dmt-video-lazy.liquid) <video> etiketini
 *    preload="none", poster="..." ve KAYNAKSIZ basar. Gerçek adres
 *    data-dmt-src içinde bekler. Kaynağı olmayan bir <video> tarayıcı için
 *    indirilecek bir şey değildir; ekranda poster karesi durur.
 *  - Burada IntersectionObserver videoyu izler. Görünür alana 300px kala
 *    <source> takılır, load() çağrılır ve (istenmişse) oynatılır.
 *  - Görünür alandan çıkınca duraklatılır: pil ve bant genişliği boşa gitmesin.
 *
 * Tema betikleriyle çakışma:
 *  video-reels.js ve low-power-video.js, videonun ekranda olup olmadığına
 *  bakmadan doğrudan video.play() çağırıyor. Sayfa açılır açılmaz aktif reel
 *  slaytını oynatmaya çalışması, ekranın 2400px altındaki bir videoyu indirmesi
 *  demekti. Bu yüzden her öğenin kendi play() metodu sarmalanıyor: öğe ekranda
 *  değilse çağrı yutulup "oynatma isteği" olarak saklanıyor, öğe görünür alana
 *  girdiğinde gerçekleşiyor. Tema betiklerine dokunulmuyor.
 *
 * ---------------------------------------------------------------------------
 * 2026-08 DÜZELTMESİ — "video bazen oynamıyor"
 *
 * Ölçülen belirti (gerçek Chrome, ürün sayfası, olay günlüğü):
 *     play() çağrıldı  ready=0
 *     evt:emptied      net=3     <-- load()'un sıfırlaması play()'DEN SONRA
 *     evt:play
 *     evt:waiting / loadstart / stalled
 *
 * Kök neden: startPlayback() önce hydrate() çağırıyordu, hydrate() ise
 * video.load() çalıştırıyor. load() eşzamanlı değildir — "kaynak seçimi
 * algoritması"nı sıraya koyar ve o algoritmanın ilk adımı bekleyen tüm
 * oynatma isteklerini iptal etmektir (medya öğesi "emptied" durumuna döner).
 * play() hemen ardından EŞZAMANLI çağrıldığı için istek, kendisinden sonra
 * çalışan sıfırlamaya yakalanıp
 *     AbortError: The play() request was interrupted by a new load request
 * ile reddediliyordu. Eski kod bu reddi boş bir catch ile yutuyor ve BİR DAHA
 * DENEMİYORDU; video poster karesinde donup kalıyordu. Yarış olduğu için
 * bazen tutuyor bazen tutmuyordu — kullanıcının "bazen" demesinin sebebi bu.
 *
 * İkinci yol: kullanıcı bölümü hızlıca geçerse, görünür alandan çıkışta
 * çağrılan pause() bekleyen play() isteğini
 *     AbortError: The play() request was interrupted by a call to pause()
 * ile iptal ediyor. (Bu ikisi de canlı sayfada üretilip günlüğe alındı.)
 *
 * Düzeltme:
 *  1. Kaynak takıldıktan sonra play() eşzamanlı çağrılmıyor; öğe hazır
 *     olduğunda (loadeddata / canplay) veya bir sonraki karede deneniyor.
 *  2. play() sözü artık MUTLAKA yakalanıyor. AbortError ise yeniden
 *     deneniyor (en çok üç kez). Tarayıcı otomatik oynatmayı reddettiyse
 *     (NotAllowedError) video sessizce donmuyor: yerel kontroller açılıyor,
 *     kullanıcı dokununca oynuyor.
 *  3. Görünür alana her yeniden girişte, video hâlâ duraklamışsa yeniden
 *     deneniyor; sayaç sıfırlanıyor.
 *
 * Tembel yükleme davranışı DEĞİŞMEDİ: <source> hâlâ yalnızca ilk kesişmede
 * takılıyor, preload="none" korunuyor, açılışta inen bayt sıfır.
 * ---------------------------------------------------------------------------
 *
 * Dayanıklılık:
 *  - JS hiç çalışmazsa video alanı boş kalmaz; poster görünür (sayfa düzeni
 *    aynı, CLS yok). Sadece otomatik oynatma olmaz.
 *  - IntersectionObserver yoksa (çok eski tarayıcı) eski davranışa dönülür.
 *  - Swiper "loop" modunda slaytları cloneNode ile çoğaltıyor. Klonlar JS
 *    özelliklerini taşımaz ama data-* özniteliklerini taşır; bu yüzden
 *    "işlendi" bilgisi öznitelikte değil WeakSet'te tutuluyor ve yeni düğümler
 *    MutationObserver ile yakalanıyor.
 */
(function () {
  'use strict';

  if (window.__dmtVideoLazyLoaded) return;
  window.__dmtVideoLazyLoaded = true;

  var SELECTOR = 'video[data-dmt-lazy]';
  var bound = new WeakSet();

  /* Aynı öğe için üstüste deneme sayısı. Üçten sonra ısrar etmiyoruz:
     sebep ağ değil politika ise deneme sayısı bir şeyi değiştirmez, bunun
     yerine kullanıcıya kontrol veriyoruz. */
  var MAX_DENEME = 3;

  var prefersReducedMotion = false;
  try {
    prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  } catch (e) {
    prefersReducedMotion = false;
  }

  /* Kaynağı tak. Zaten <source> taşıyan öğe (ör. Swiper klonu) atlanır. */
  function hydrate(video) {
    if (video.querySelector('source')) return false;

    var src = video.getAttribute('data-dmt-src');
    if (!src) return false;

    var source = document.createElement('source');
    source.setAttribute('src', src);

    var type = video.getAttribute('data-dmt-type');
    if (type) source.setAttribute('type', type);

    /* preload="none" yalnızca SAYFA AÇILIŞI için gerekliydi ve asıl güvence
       zaten kaynağın hiç basılmamış olması. Bu noktada video görünür alana
       girdi; preload'ı açmazsak tarayıcı "gerekmedikçe indirme" talimatına
       uyup load() sonrası hiç veri çekmeyebilir, o zaman canplay hiç gelmez
       ve yeniden deneme yolu da ölür. Tembel yükleme garantisi bozulmuyor:
       buraya yalnızca kesişme anında geliniyor. */
    video.preload = 'auto';
    video.appendChild(source);
    video.load();
    return true;
  }

  function shouldAutoplay(video) {
    /* Hareketi azalt tercihi: poster'da kal, kendiliğinden oynatma. */
    if (prefersReducedMotion) return false;
    return video.getAttribute('data-dmt-autoplay') === 'true';
  }

  /* Otomatik oynatma reddedildi. Video poster karesinde donmuş kalmasın;
     yerel kontrolleri açıp kullanıcıya oynatma düğmesi bırakıyoruz. */
  function kullaniciyaBirak(video) {
    if (video.hasAttribute('controls')) return;
    video.setAttribute('controls', '');
    video.setAttribute('data-dmt-autoplay-blocked', '');
  }

  function kontrolleriKaldir(video) {
    if (!video.hasAttribute('data-dmt-autoplay-blocked')) return;
    video.removeAttribute('controls');
    video.removeAttribute('data-dmt-autoplay-blocked');
  }

  /* Öğe oynatılabilir duruma gelince bir kez çalışacak geri çağırım.
     readyState zaten yeterliyse beklemeden çalışır. */
  function hazirOlunca(video, fn) {
    if (video.readyState >= 2 /* HAVE_CURRENT_DATA */) {
      fn();
      return;
    }
    var calisti = false;
    function bir() {
      if (calisti) return;
      calisti = true;
      video.removeEventListener('loadeddata', bir);
      video.removeEventListener('canplay', bir);
      fn();
    }
    video.addEventListener('loadeddata', bir);
    video.addEventListener('canplay', bir);
  }

  /* play() reddini yorumlayan TEK yer. Hem IntersectionObserver yolu hem de
     tema betiklerinin kullandığı sarmalanmış video.play() buradan geçiyor;
     aksi hâlde iki yoldan biri sessiz kalıyordu. */
  function redAlindi(video, err) {
    var ad = err && err.name;
    /* AbortError = istek bir load() ya da pause() tarafından kesildi.
       Gerçek bir engel değil, yarış; öğe hazır olunca tekrar dene. */
    if (ad === 'AbortError' || ad === 'NotSupportedError') {
      if (!video.__dmtInView) return;
      hazirOlunca(video, function () {
        if (video.__dmtInView && video.paused) denemeyiCalistir(video);
      });
      return;
    }
    /* NotAllowedError: tarayıcı otomatik oynatmayı reddetti (düşük güç modu,
       veri tasarrufu, kullanıcı ayarı). Israr etmek işe yaramaz — kullanıcıya
       görünür bir oynat düğmesi bırak, video poster karesinde donmasın. */
    kullaniciyaBirak(video);
  }

  function denemeyiCalistir(video) {
    if (!video.__dmtInView) return;
    if (video.__dmtDeneme >= MAX_DENEME) return;
    video.__dmtDeneme++;

    var play = video.__dmtNativePlay;
    if (!play) return;

    var result;
    try {
      result = play();
    } catch (e) {
      /* Çok eski tarayıcılar play() içinden fırlatabiliyor. */
      kullaniciyaBirak(video);
      return;
    }

    if (!result || typeof result.then !== 'function') return;

    result.then(
      function () {
        video.__dmtDeneme = 0;
        kontrolleriKaldir(video);
      },
      function (err) {
        redAlindi(video, err);
      }
    );
  }

  function startPlayback(video) {
    hydrate(video);

    /* play() yine hemen çağrılıyor — çağırmamak "preload=auto rağmen ilk
       kareyi bekle" davranışına ve gereksiz gecikmeye yol açıyor. Fark şu:
       load()'un sıfırlaması bu isteği iptal ederse (AbortError) artık sessizce
       yutulmuyor, öğe veri alır almaz yeniden deneniyor. Kök nedeni ortadan
       kaldıran şey bu yeniden deneme. */
    denemeyiCalistir(video);
  }

  var observer = null;
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var entry = entries[i];
          var video = entry.target;

          if (entry.isIntersecting) {
            video.__dmtInView = true;
            /* Geri dönüşte sayaç sıfırlanır: önceki denemelerin tükenmiş
               olması kullanıcının ikinci ziyaretini cezalandırmasın. */
            video.__dmtDeneme = 0;
            if (shouldAutoplay(video) || video.__dmtPlayRequested) {
              video.__dmtPlayRequested = false;
              startPlayback(video);
            }
          } else {
            video.__dmtInView = false;
            if (!video.paused) video.pause();
          }
        }
      },
      /* 300px: kullanıcı videoya varmadan bir tık önce yüklenmeye başlasın ki
         ekrana girdiğinde siyah kare değil hareket görsün. */
      { rootMargin: '300px 0px', threshold: 0.01 }
    );
  }

  function bindVideo(video) {
    if (bound.has(video)) return;
    bound.add(video);

    video.__dmtInView = false;
    video.__dmtPlayRequested = false;
    video.__dmtDeneme = 0;
    video.__dmtNativePlay = video.play.bind(video);

    /* Tema betiklerinin ekran dışı play() çağrılarını ertele. */
    video.play = function () {
      if (video.__dmtInView) {
        hydrate(video);
        var p = video.__dmtNativePlay();
        /* Tema betiği (video-reels.js) dönen sözü yakalamıyor; aynı
           load()/pause() yarışı ve aynı otomatik oynatma reddi burada da
           olabilir. Sözü çağırana aynen döndürüyoruz ama reddi kendi tek
           merkezimizden geçiriyoruz. */
        if (p && typeof p.then === 'function') {
          p.then(
            function () {
              video.__dmtDeneme = 0;
              kontrolleriKaldir(video);
            },
            function (err) {
              redAlindi(video, err);
            }
          );
        }
        return p;
      }
      video.__dmtPlayRequested = true;
      return Promise.resolve();
    };

    if (observer) {
      observer.observe(video);
    } else {
      hydrate(video);
      if (shouldAutoplay(video)) {
        video.__dmtInView = true;
        startPlayback(video);
      }
    }
  }

  function scan(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = scope.querySelectorAll(SELECTOR);
    for (var i = 0; i < list.length; i++) bindVideo(list[i]);

    /* MutationObserver'dan gelen düğümün kendisi de hedef olabilir. */
    if (root && root.matches && root.matches(SELECTOR)) bindVideo(root);
  }

  /* Sekme arkaplana geçince oynatmayı durdur; öne dönünce görünür olanları
     yeniden dene (arkaplandayken duraklatılan video geri gelince donmasın). */
  document.addEventListener('visibilitychange', function () {
    var list = document.querySelectorAll(SELECTOR);
    var i;
    if (document.hidden) {
      for (i = 0; i < list.length; i++) {
        if (!list[i].paused) list[i].pause();
      }
      return;
    }
    for (i = 0; i < list.length; i++) {
      var v = list[i];
      if (v.__dmtInView && v.paused && shouldAutoplay(v)) {
        v.__dmtDeneme = 0;
        startPlayback(v);
      }
    }
  });

  /* Swiper klonları ve bölüm yeniden çizimleri (tema düzenleyicisi) için. */
  if ('MutationObserver' in window) {
    var pending = false;
    var queue = [];
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          if (added[j].nodeType === 1) queue.push(added[j]);
        }
      }
      if (!queue.length || pending) return;
      pending = true;
      /* Aynı karede onlarca slayt eklenebiliyor; tek seferde tara. */
      requestAnimationFrame(function () {
        pending = false;
        var nodes = queue;
        queue = [];
        for (var k = 0; k < nodes.length; k++) scan(nodes[k]);
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scan(document);
    });
  } else {
    scan(document);
  }
})();
